export default {"src":"/_next/static/media/search-all-results.32f862d7.gif","height":540,"width":800};